import { Component, inject } from '@angular/core';
import { DxButtonComponent } from 'devextreme-angular';
import { NavigatorService } from 'src/app/shared/services/navigator.service';

@Component({
  selector: 'app-btn-new-dipendente',
  templateUrl: './btn-new-dipendente.component.html',
  styleUrls: ['./btn-new-dipendente.component.scss'],
  imports: [DxButtonComponent]
})
export class BtnNewDipendenteComponent {

  private navService = inject(NavigatorService);

  goToDipendenteNew() {
    this.navService.goToDipendentiNew();
  }

}


